import Heading from "../../components/heading/Heading";
import Image from "../../components/image/Image";
import { Paragraph } from "../../components/paragraph/Paragraph";

export function MediaTextLeftImage({
  imageSrc,
  imageAlt,
  title,
  text,
  ...rest
}) {
  return (
    <div
  {...rest}
  className="flex flex-col md:flex-row items-center justify-center gap-6 w-full"
>
  {/* Image Section */}
  <div className="w-full md:w-1/2">
    <Image
      src={imageSrc}
      alt={imageAlt}
      className="w-full h-auto object-cover mx-auto"
    />
  </div>

  {/* Text Section */}
  <div className="w-full md:w-1/2 text-center md:text-left px-4">
    <Heading level={3} className="text-3xl md:text-4xl font-bold text-white mb-4">
      {title}
    </Heading>
    <Paragraph className="text-gray-100 font-semibold text-lg md:text-xl leading-relaxed">
      {text}
    </Paragraph>
  </div>
</div>

  );
}
